import { Row, Col, FormGroup } from 'react-bootstrap';
import React, { Component } from 'react';
import FormularioPadrao from './../FormularioPadrao';
//import Select from '../../components/Select';
import Label from '../../components/Label';
import TextInput from '../../components/TextInput';
import DateInput from '../../components/DateInput';
import IntegerInput from '../../components/IntegerInput';
import TextArea from '../../components/TextArea';
import TipoDeEquipamentoController from '../../controllers/Neos/TipoDeEquipamentoController';
import { updateState, dateToString } from '../../utils/Functions';
import Select from '../../components/Select';
import Document from '../../components/Document';
import SubCadastro from '../../components/SubCadastro';

export default class TipoDeEquipamentoView extends Component {
   constructor(props) {
      super(props);
      this.state = { mostrarAcessos: true, podeAlterarCodigo: true };
      this.controller = new TipoDeEquipamentoController(this);
   }

   renderizarFormulario = () => {
      let lang = this.props.lang;
      let telaDeCadastroDeTipoDeEquipamento = lang.telaDeCadastroDeTipoDeEquipamento;
      return (
         <React.Fragment>
            <Row>
               <Col sm={2} md={2} lg={2}>
                  <FormGroup>
                     <Label>{lang.codigo}</Label>
                     <IntegerInput
                        readOnly={this.state.podeAlterarCodigo}
                        defaultValue={this.state.itemSelecionado.id}
                        onChange={(e) => {
                           updateState(this, (state) => {
                              state.itemSelecionado.id = e.value;
                           });
                        }}
                     />
                  </FormGroup>
               </Col>

               <Col>
                  <FormGroup>
                     <Label>{telaDeCadastroDeTipoDeEquipamento.nome}</Label>
                     <TextInput
                        defaultValue={this.state.itemSelecionado.nome}
                        onChange={(e) => {
                           updateState(this, (state) => {
                              state.itemSelecionado.nome = e.target.value;
                           });
                        }}
                        upperCase={true}
                     />
                  </FormGroup>
               </Col>

               <Col sm={3} md={3} lg={3}>
                  <FormGroup>
                     <Label>{telaDeCadastroDeTipoDeEquipamento.situacao}</Label>
                     <Select
                        name="situacao"
                        defaultValue={this.state.itemSelecionado.situacao && this.state.itemSelecionado.situacao.id}
                        options={[
                           {
                              id: 1,
                              descricao: lang.telaDeCadastroDeTipoDeEquipamento.ativo,
                           },
                           {
                              id: 2,
                              descricao: lang.telaDeCadastroDeTipoDeEquipamento.inativo,
                           },
                        ]}
                        getKeyValue={(i) => i.id}
                        getDescription={(i) => i.descricao}
                        onSelect={(i) => {
                           updateState(this, (state) => {
                              state.itemSelecionado.situacao = i;
                           });
                        }}
                     />
                  </FormGroup>
               </Col>
            </Row>

            <Row>
               <Col>
                  <FormGroup>
                     <Label>{telaDeCadastroDeTipoDeEquipamento.sigla}</Label>
                     <TextInput
                        defaultValue={this.state.itemSelecionado.sigla}
                        onChange={(e) => {
                           updateState(this, (state) => {
                              state.itemSelecionado.sigla = e.target.value;
                           });
                        }}
                        upperCase={true}
                     />
                  </FormGroup>
               </Col>

               <Col>
                  <FormGroup>
                     <Label>{telaDeCadastroDeTipoDeEquipamento.tipoDeSequencia}</Label>
                     <Select
                        as="select"
                        name="tipoDeSequencia"
                        defaultValue={this.state.itemSelecionado.tipoDeSequencia}
                        options={[
                           { id: 0, descricao: 'ABI' },
                           { id: 1, descricao: 'JAU' },
                           { id: 2, descricao: 'JAUMP' },
                           { id: 3, descricao: 'SMP' },
                           { id: 4, descricao: 'SIM' },
                           { id: 7, descricao: 'SEG' },
                           { id: 6, descricao: 'TIN' },
                           { id: 5, descricao: 'ASE' },
                           { id: 8, descricao: 'SOP/MOX' },
                           { id: 9, descricao: 'AVM' },
                           { id: 10, descricao: 'APE' },
                           { id: 11, descricao: 'AQT' },
                           { id: 12, descricao: 'MMD' },
                           { id: 13, descricao: 'SMP/SPK' },
                           { id: 14, descricao: 'MDC' },
                        ]}
                        acceptZero={true}
                        getKeyValue={(i) => i.id}
                        getDescription={(i) => i.descricao}
                        onSelect={(i) => {
                           updateState(this, (state) => {
                              state.itemSelecionado.tipoDeSequencia = i ? i.id : null;
                           });
                        }}
                     />
                  </FormGroup>
               </Col>
            </Row>

            <Row>
               <Col>
                  <FormGroup>
                     <Label>{telaDeCadastroDeTipoDeEquipamento.descricao}</Label>
                     <TextArea
                        defaultValue={this.state.itemSelecionado.descricao}
                        onChange={(e) => {
                           updateState(this, (state) => {
                              state.itemSelecionado.descricao = e.target.value;
                           });
                        }}
                        upperCase={true}
                     />
                  </FormGroup>
               </Col>
            </Row>

            {this.state.itemSelecionado && this.state.itemSelecionado.id && (
               <SubCadastro
                  titulo={telaDeCadastroDeTipoDeEquipamento.anexos}
                  exibirTitulos={true}
                  itens={this.state.itemSelecionado?.anexos ?? []}
                  lang={lang}
                  novo={() => {
                     return new Promise((resolve) => {
                        updateState(this, (state) => {
                           state.anexoSelecionado = {
                              descricao: null,
                              arquivo: null,
                           };
                        }).then(() => resolve());
                     });
                  }}
                  inserir={this.controller.inserirAnexo}
                  selecionarParaAlteracao={(index) => {
                     return new Promise((resolve) => {
                        updateState(this, (state) => {
                           state.anexoSelecionado = JSON.parse(
                              JSON.stringify(state.itemSelecionado.anexos[index])
                           );
                        }).then(() => resolve());
                     });
                  }}
                  alterar={this.controller.alterarAnexo}
                  cancelar={() => {
                     return new Promise((resolve) => {
                        updateState(this, (state) => {
                           state.anexoSelecionado = null;
                        }).then(() => resolve());
                     });
                  }}
                  excluir={(index) => {
                     updateState(this, (state) => {
                        state.itemSelecionado.anexos.splice(index, 1);
                     });
                  }}
                  colunas={() => {
                     return [
                        {
                           titulo: lang.anexo?.descricao ?? '',
                           width: '40%',
                           className: null,
                        },
                        {
                           titulo: lang.anexo?.arquivo ?? '',
                           width: '60%',
                           className: null,
                        },
                     ];
                  }}
                  linha={(item) => {
                     return [
                        item?.descricao ?? '',
                        item?.anexo?.descricao ?? '',
                     ];
                  }}
                  formulario={() => {
                     return (
                        this.state.anexoSelecionado && (
                           <div>
                              <Row>
                                 <Col xs={6} md={6} xl={6}>
                                    <FormGroup>
                                       <Label>{lang.anexo.descricao}</Label>
                                       <TextInput
                                          name="descricao"
                                          defaultValue={this.state.anexoSelecionado?.descricao ?? ''}
                                          maxLength={100}
                                          onChange={(e) => {
                                             updateState(this, (state) => {
                                                if (state.anexoSelecionado) {
                                                   state.anexoSelecionado.descricao = e.target.value;
                                                }
                                             });
                                          }}
                                       />
                                    </FormGroup>
                                 </Col>
                                 <Col xs={6} md={6} xl={6}>
                                    <FormGroup>
                                       <Label>{lang.anexo.arquivo}</Label>
                                       <Document
                                          lang={this.props.lang}
                                          api={this.props.api}
                                          maxSize={2 * 1024 * 1024}
                                          defaultValue={this.state.anexoSelecionado?.arquivo}
                                          onChange={(file) => {
                                          updateState(this, (state) => {
                                             if (state.anexoSelecionado) {
                                                state.anexoSelecionado.arquivo = file;
                                             }
                                          });
                                          }}
                                       />
                                    </FormGroup>
                                    </Col>
                              </Row>
                           </div>
                        )
                     );
                  }}
               />
            )}
            <br />

            {this.state.itemSelecionado && this.state.itemSelecionado.id && (
               <SubCadastro
                  titulo={telaDeCadastroDeTipoDeEquipamento.firmwares}
                  exibirTitulos={true}
                  itens={this.state.itemSelecionado.firmwares}
                  lang={lang}
                  novo={() => {
                     return new Promise((resolve) => {
                        updateState(this, (state) => {
                           state.firmwareSelecionado = {
                              numeroDaVersao: null,
                              dataDeLiberacao: null,
                              descricaoDasAlteracoes: null,
                              arquivoDeFirmware: null,
                           };
                        }).then(() => resolve());
                     });
                  }}
                  inserir={this.controller.inserirFirmware}
                  selecionarParaAlteracao={(index) => {
                     return new Promise((resolve) => {
                        updateState(this, (state) => {
                           state.firmwareSelecionado = JSON.parse(
                              JSON.stringify(state.itemSelecionado.firmwares[index])
                           );
                        }).then(() => resolve());
                     });
                  }}
                  alterar={this.controller.alterarFirmware}
                  cancelar={() => {
                     return new Promise((resolve) => {
                        updateState(this, (state) => {
                           state.firmwareSelecionado = null;
                        }).then(() => resolve());
                     });
                  }}
                  excluir={(index) => {
                     updateState(this, (state) => {
                        state.itemSelecionado.firmwares.splice(index, 1);
                     });
                  }}
                  colunas={() => {
                     return [
                        {
                           titulo: lang.firmware.numeroDaVersao,
                           width: '20%',
                           className: null,
                        },
                        {
                           titulo: lang.firmware.dataDeLiberacao,
                           width: '20%',
                           className: null,
                        },
                        {
                           titulo: lang.firmware.descricaoDasAlteracoes,
                           width: '30%',
                           className: null,
                        },
                        {
                           titulo: lang.firmware.arquivoDeFirmware,
                           width: '30%',
                           className: null,
                        },
                     ];
                  }}
                  linha={(item) => {
                     return [
                        item.numeroDaVersao,
                        dateToString(item.dataDeLiberacao, this.props.lang),
                        item.descricaoDasAlteracoes,
                        item.arquivoDeFirmware ? item.arquivoDeFirmware.descricao : null,
                     ];
                  }}
                  formulario={() => {
                     return (
                        this.state.firmwareSelecionado && (
                           <div>
                              <Row>
                                 <Col xs={3} md={3} xl={3}>
                                    <FormGroup>
                                       <Label>{lang.firmware.numeroDaVersao}</Label>
                                       <TextInput
                                          name="numeroDaVersao"
                                          defaultValue={this.state.firmwareSelecionado.numeroDaVersao}
                                          maxLength={10}
                                          onChange={(e) => {
                                             updateState(this, (state) => {
                                                state.firmwareSelecionado.numeroDaVersao = e.target.value;
                                             });
                                          }}
                                       />
                                    </FormGroup>
                                 </Col>
                                 <Col xs={3} md={3} xl={3}>
                                    <FormGroup>
                                       <Label>{lang.firmware.dataDeLiberacao}</Label>
                                       <DateInput
                                          // defaultValue={
                                          //    this.state.firmwareSelecionado.dataDeLiberacao
                                          //       ? this.state.firmwareSelecionado.dataDeLiberacao
                                          //       : new Date()
                                          // }
                                          onChange={(value) => {
                                             updateState(this, (state) => {
                                                state.firmwareSelecionado.dataDeLiberacao = value;
                                             });
                                          }}
                                       />
                                    </FormGroup>
                                 </Col>
                                 <Col xs={3} md={3} xl={3}>
                                    <FormGroup>
                                       <Label>{lang.firmware.descricaoDasAlteracoes}</Label>
                                       <TextInput
                                          name="descricaoDasAlteracoes"
                                          defaultValue={this.state.firmwareSelecionado.descricaoDasAlteracoes}
                                          onChange={(e) => {
                                             updateState(this, (state) => {
                                                state.firmwareSelecionado.descricaoDasAlteracoes = e.target.value;
                                             });
                                          }}
                                       />
                                    </FormGroup>
                                 </Col>
                                 <Col xs={6} md={6} xl={6}>
                                    <FormGroup>
                                       <Label>{lang.firmware.arquivoDeFirmware}</Label>
                                       <Document
                                          lang={this.props.lang}
                                          api={this.props.api}
                                          accept="application/zip"
                                          defaultValue={this.state.firmwareSelecionado.arquivoDeFirmware}
                                          onChange={(file) => {
                                             updateState(this, (state) => {
                                                state.firmwareSelecionado.arquivoDeFirmware = file;
                                             });
                                          }}
                                       />
                                    </FormGroup>
                                 </Col>
                              </Row>
                           </div>
                        )
                     );
                  }}
               />
            )}

            <br />
            
         </React.Fragment>
      );
   };

   render() {
      return (
         <FormularioPadrao
            titulo={this.props.lang.telaDeCadastroDeTipoDeEquipamento.titulo}
            url={'/tipodeequipamento'}
            // fastUrl={'/tipodeequipamento/fast'}
            api={this.props.api}
            lang={this.props.lang}
            ordenacaoPadrao={'nome'}
            permissoes={[1051, 1052, 1053, 1054]}
            getFiltro={this.controller.getFiltro}
            getTitulosDaTabela={this.controller.getTitulosDaTabela}
            getDadosDaTabela={this.controller.getDadosDaTabela}
            renderizarFormulario={this.renderizarFormulario}
            getObjetoDeDados={this.controller.getObjetoDeDados}
            antesDeInserir={this.controller.antesDeInserir}
            antesDeEditar={this.controller.antesDeEditar}
            antesDeSalvar={this.controller.antesDeSalvar}
            antesDeExcluir={this.controller.antesDeExcluir}
            getFormState={() => {
               return this.state;
            }}
            setFormState={(state, callback) => {
               return new Promise((resolve) => {
                  this.setState(state, () => {
                     resolve();
                     if (callback) {
                        callback();
                     }
                  });
               });
            }}
            select={this.props.select}
            itemVazio={{
               situacao: { id: 1 },
               acessos: [],
            }}
         />
      );
   }
}
